import { keyPositionRequestFormData } from "../KeyPositionRequestForm.data";


export const setAllDropDownField = (apiResponse) => {    
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "currentJobLevel": filterDropDownList("Job Level"),
        "currentJobFunction": filterDropDownList("Job Function"),
        "currentMobile": filterDropDownList("Country Code"),
        "currentTelephone": filterDropDownList("Country Code"),
        "currentFirstName": filterDropDownList("Salutation"),
        //
        "newJobLevel": filterDropDownList("Job Level"),
        "newJobFunction": filterDropDownList("Job Function"),
        "newMobile": filterDropDownList("Country Code"),
        "newTelephone": filterDropDownList("Country Code"),
        "newFirstName": filterDropDownList("Salutation"),
    };

    const formFields = [...keyPositionRequestFormData?.positionInfo?.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];

        field.fieldSetting.options = Array.isArray(dropdownList)
            ? dropdownList
            : [];
    });

};
